module.exports = __webpack_public_path__ + "img/weixin.d49a0b71.png";